// aqui fica as meta tags que são comuns para todas as paginas
const isProduction = process.env.NODE_ENV === 'production';

export default {
    title: 'A Rádio Online mais ouvida do Brasil',
    meta:
    {
        description: 'Escute já a rádio online mais ouvida do Brasil e fique por dentro das grandes novidades do mundo da música. Venha para a Antena 1!',
        keywords: 'Antena 1, artistas, noticias, promoção, antena1, radio, rádio, ouvintes,flashback, anos 80, anos 70, música de qualidade, música internacional, musica internacional, musica de qualidade, música boa, programação especial, lounge music, música romântica, musica romantica',
        'og:title': 'A Rádio Online mais ouvida do Brasil',
        'og:description': 'Escute já a rádio online mais ouvida do Brasil e fique por dentro das grandes novidades do mundo da música. Venha para a Antena 1!',
        'og:image': 'https://a1media.antena1.com.br/image/share/antena1.png',
        'og:image:width': '1200',
        'og:image:height': '630',
        'og:type': 'website',
        'og:site_name': 'Antena 1',
        'fb:app_id': isProduction ? '464777950352006' : '841963372562869',
        // "og:url": __CLIENT__ && location.href // this will be injected by the HeaderTags component See old comment, in case of problems -> //removed this as it would tell facebook to scrape the given url instead of the current url(https://stackoverflow.com/questions/7830846/ogurl-is-driving-me-crazy). (this causes problems with ssr)
    },
};
